export default "__VITE_ASSET__C8aZA0Fl__"